import React from "react";
import { defineMessages, useIntl } from "react-intl";

import { Badge, Popover, Stack, Text } from "../ui";

const messages = defineMessages({
  alt: { id: "image.alt", defaultMessage: "ALT" },
  altTitle: {
    id: "image.alt_dialog.title",
    defaultMessage: "Image Description",
  },
  altButton: { id: "image.alt_dialog.button", defaultMessage: "Dismiss" },
  gif: { id: "image.gif", defaultMessage: "GIF" },
});

interface AltPopoverProps {
  description: string;
}

function AltPopover(props: AltPopoverProps) {
  const intl = useIntl();

  return (
    <div className="group relative">
      <Popover
        interaction="click"
        content={
          <Stack space={2} className="w-56 text-center">
            <Text size="lg" weight="bold">
              {intl.formatMessage(messages.altTitle)}
            </Text>
            <Text size="sm" theme="muted">
              {props.description}
            </Text>
          </Stack>
        }
        dismissText={intl.formatMessage(messages.altButton)}
      >
        <div>
          <Badge variant="overlay" className="cursor-pointer">
            {intl.formatMessage(messages.alt)}
          </Badge>
        </div>
      </Popover>
    </div>
  );
}

export default AltPopover;
